<template>
  <ClientOnly>
    <section-wrapper class="bg-ternary max-lg:hidden">
      <section-container mobile-padding class="max-w-container py-16">
        <search-driver-form
          ref="searchFormRef"
          class="relative z-[1]"
          @search="searchResult"
          @initSearch="initSearch"
          :origin-id="originId"
          :dropfilter="dropfilter"
          :destination-id="destinationId"
          :date-input="date"
        ></search-driver-form>
      </section-container>
    </section-wrapper>
    <section-wrapper>
      <section-container
        mobile-padding
        class="max-w-container grid-cols-12 gap-5 pb-16 pt-16 lg:grid"
      >
        <div class="col-span-3">
          <div
            class="bg-primary mb-5 rounded-2xl px-8 py-10 pb-[5.2rem] text-white"
          >
            <div class="flex flex-col">
              <div v-if="loading" class="text-whit mb-5 text-[2rem] leading-10">
                <div class="font-bold">Recherche</div>
                <div>en cours...</div>
              </div>

              <div v-else class="text-whit mb-5 text-[2rem] leading-10">
                <div class="font-bold">{{ meta.total }} demandes </div>
                <div>actives</div>
              </div>

              <div
                v-if="date"
                class="text-primary-lighter mb-2 flex items-center text-[0.938rem]"
              >
                <icon icon="calendrier" class="mr-2 h-3 w-3"></icon>
                {{ dayjs(date).format("DD MMMM YYYY") }}
              </div>
              <div v-if="origin || destination" class="flex h-full">
                <div class="mr-3 flex flex-col items-center py-2">
                  <div
                    v-if="origin"
                    class="bg-secondary h-4 w-4 rounded-full"
                  ></div>
                  <div
                    v-if="origin && destination"
                    class="border-primary-lighter grow border-l-4 border-dotted border-opacity-60"
                  ></div>
                  <div
                    v-if="destination"
                    class="bg-ternary h-4 w-4 rounded-full"
                  ></div>
                </div>

                <div>
                  <div
                    class="group-hover:text-primary text-[1.25rem] font-semibold uppercase text-white"
                  >
                    <span v-if="origin">
                      {{ origin.name }}
                    </span>
                  </div>
                  <div
                    class="group-hover:text-primary text-[1.25rem] font-semibold uppercase text-white"
                  >
                    <span v-if="destination">
                      {{ destination.name }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        
        </div>
        <div class="col-span-9">
          <div
            v-if="routes.length === 0 && !loading"
            class="text-primary-lightest flex h-[20rem] items-center justify-center text-4xl font-bold uppercase"
          >
          Aucune demande disponible
          </div>
          <div v-else class="flex flex-col gap-6">
            
            <template v-for="route in computeRoutes">
              <available-driver-route-card :route="route" @book="book(route)">
              </available-driver-route-card>
            </template>
          </div>
          <spinner v-if="loading" class="mx-auto"></spinner>

          <div
            class="max-w-container flex items-center justify-center py-16"
            v-if="meta && meta.current_page < meta.last_page"
          >
            <rounded-button @click="showMoreResults" design="1"
              >Afficher plus de résultats
            </rounded-button>
          </div>
        </div>
      </section-container>
    </section-wrapper>
  </ClientOnly>
</template>

<script setup>
import { useNuxtApp } from "#app";
import { computed, onMounted, ref } from "vue";
import { defineProps } from "vue";
import { useRoute } from "vue-router";
import AvailableDriverRouteCard from "../components/cards/routes/AvailableDriverRouteCard.vue";
import InfiniteLoading from "v3-infinite-loading";
import "v3-infinite-loading/lib/style.css";
import dayjs from "dayjs";
import Dialog from "primevue/dialog";
import { useAuthStore } from "~/store/auth";

const { $api, $event, $listen, $unListen, $router } = useNuxtApp();
const router = useRouter();
const route = useRoute();

const orderByOptions = ref([
  { value: "earlier", label: "Départ le plus tôt" },
  { value: "price", label: "Prix le plus bas" },
  // { value: "near_origin", label: "Proche point de départ" },
  // { value: "near_destination", label: "Proche point d'arrivée" },
]);

const CoffinTypeFilterOptions = ref([
  { value: "", label: "Indifférent" },
  { value: "before_coffin", label: "Avant mise en bière" },
  { value: "after_coffin", label: "Après mise en bière" },
  
]);

const sizeOptions = ref([
  { label: "Indifférent", value: 1 },
  {
    label: "Hors-normes",
    hint: "Dimensions intérieures du cercueil > 195cm x 60cm",
    value: 0,
  },
]);

const coffinType = ref("");
const size = ref(1);
const orderBy = ref("earlier");

const sortedRoutes = computed(() => {
  let sortedRoutes = routes.value;
  if (sortByCoffinType.value === "before_coffin") {
    sortedRoutes = sortedRoutes.filter((route) => {
      return route.coffin_type !== "after_coffin";
    });
  } else if (sortByCoffinType.value === "after_coffin") {
    sortedRoutes = sortedRoutes.filter((route) => {
      return route.coffin_type !== "before_coffin";
    });
  }
  
  return !!origin.value && !!destination.value;
});

const routes = ref([]);
const showAll = ref(false);
const originId = ref();
const dropfilter = ref();

const destinationId = ref();
const origin = ref();
const destination = ref();
const date = ref();
const loading = ref(false);
const searchFormRef = ref(null);
const { me } = useAuthStore();
const meta = ref({
  current_page: 1,
  from: 1,
  last_page: 1,
  per_page: 10,
  total: 0,
});

const book = (route) => { 


  if (me) {
      console.log("hello3",route);
    $event("driverbooking.requested", route);
  } else {
    $router.push("/auth/login");
  }
};

const showMoreResults = () => {
  getRoutes(meta.value.current_page + 1);
};

const getRoutes = (page = null) => {
  loading.value = true;

  if (!page) {
    routes.value = [];
  }

  const params = {
    origin: originId.value,
    dropfilter: dropfilter.value,
    destination: destinationId.value,
    date: date.value ? dayjs(date.value).format("DD/MM/YYYY") : null,
    orderBy: orderBy.value ? orderBy.value : null,
    coffinType: coffinType.value ? coffinType.value : null,
    size: size.value ? size.value : null,
    page: page ? page : null,
  };

  return $api
    .call("get", $api.route("driverroutes.index"), null, params, true)
    .then((res) => {
      if (page) {
        routes.value = [...routes.value, ...res.data.data];
      } else {
        routes.value = res.data.data;
      }

      meta.value = res.data.meta;
    })
    .finally(() => {
      loading.value = false;
    });
};

watch(
  () => searchFormRef.value,
  (searchForm) => {
    if (!searchForm) {
      return;
    }

    searchForm.updateFields();
  },
  { immediate: true }
);


onMounted(async () => {

  originId.value = route.query?.origin ? parseInt(route.query?.origin) : null;
  destinationId.value = route.query?.destination
    ? parseInt(route.query?.destination)
    : null;
  date.value = route.query?.date ? dayjs(route.query.date).toDate() : null;
  dropfilter.value = route.query?.dropfilter ? route.query?.dropfilter : null;

  $listen("booking.created", getRoutes);

  await getRoutes();
});

onBeforeUnmount(() => {
  $unListen("booking.created", getRoutes);
});

const searchResult = (payload) => {
  origin.value = payload.origin;
  originId.value = payload.origin?.id;
  dropfilter.value = payload.dropfilter;

  destination.value = payload.destination;


  destinationId.value = payload.destination?.id;
  date.value = payload.date ? dayjs(payload.date).format("YYYY-MM-DD") : null;

  return getRoutes();
};

const initSearch = (payload) => {
  origin.value = payload.origin;
  destination.value = payload.destination;
  dropfilter.value = payload.dropfilter;

  
};

const computeRoutes = computed(() => {
  return routes.value;
  let sortedRoutes = routes.value;
  console.log("mrshah");
  if (sortByCoffinType.value === "before_coffin") {
    sortedRoutes = sortedRoutes.filter((route) => {
      return route.type !== "after_coffin";
    });
  } else if (sortByCoffinType.value === "after_coffin") {
    sortedRoutes = sortedRoutes.filter((route) => {
      return route.type !== "before_coffin";
    });
  }
  if (showAll.value) {
    return sortedRoutes;
  }
  return sortedRoutes.slice(0, 3);
});

const toggleShowAll = () => {
  showAll.value = !showAll.value;
};
</script>
```
